import { inject, Injectable } from '@angular/core';
import { collection, collectionData, Firestore } from '@angular/fire/firestore';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShippingService {
  private firestore = inject(Firestore);

  getShippingPrice(province?: string | null, city?: string | null) {
    const shippingCollection = collection(this.firestore, 'shipping_rates');

    return collectionData(shippingCollection, { idField: 'id' }).pipe(
      map((rates: any[]) => {
        // handle null/empty
        if (!province && !city) {
          const defaultRate = rates.find(r => r.id === 'default');
          return defaultRate?.price || 0;
        }

        const provinceLower = province?.toLowerCase() || '';
        const cityLower = city?.toLowerCase() || '';

        let provincePrice: number | null = null;
        let defaultPrice: number = 0;

        for (const rate of rates) {
          if (rate.id === 'default') {
            defaultPrice = rate.price;
          }

          if (rate.province?.toLowerCase() === provinceLower) {
            // city-specific price
            if (rate.cities && rate.cities[cityLower] !== undefined) {
              return rate.cities[cityLower];
            }
            // fallback to province price
            provincePrice = rate.price;
          }
        }

        return provincePrice !== null ? provincePrice : defaultPrice;
      })
    );
  }
}